module.exports = __webpack_public_path__ + "static/desktop/img/swiper-2.ee7ba65c.jpg";